import src from "IMAGE";
export default { src, width: 175, height: 48, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/ACQzLksvQzxeNEpDaj1YT38qPTdTLEA6Wy1BO106U0t4ADhQSXRGZFuOMUY/ZyY3Mk4oOTNQNk1GbSo9N1Y0SkNqQX4Rvvdw0i8AAAAASUVORK5CYII=", blurWidth: 8, blurHeight: 2 }
